<template>
  <el-dialog
    :visible.sync="show"
    :fullscreen="true"
    :close-on-click-modal="false"
    :show-close="false"
    custom-class="sign-contract-dialog"
  >
    <div class="sign-page">
      <SignImg
        v-if="signImgShow"
        :showFunction="showFunction"
        :signSuccess="signSuccess"
        :signerName="signerName"
      />
      <div class="sign-page__tip">
        <span class="sign-page__tip-dot"></span>
        <span>请仔细阅读合同全文，确认无误后完成签名并提交</span>
      </div>
      <div ref="pdfViewer" class="sign-page__pdf">
        <div id="preViewPdf"></div>
      </div>
      <div class="sign-page__footer">
        <button
          type="button"
          class="sign-page__btn sign-page__btn--ghost"
          @click="sign"
        >
          使用签名
        </button>
        <button
          type="button"
          class="sign-page__btn sign-page__btn--primary"
          :disabled="loading"
          @click="savePdf"
        >
          {{ loading ? '提交中...' : '确认提交' }}
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import DragImg from "./DragImg";
import SignImg from "./SignImg";
import Vue from "vue";
import printStyle from "./printStyle";
import JsPDF from "jspdf";
import html2canvas from "html2canvas";
import "uni-webview-lib";
import {
  buildApiPaths,
  formatAuthHeader,
  hasBackendSeal,
} from "../../utils/signApi";
import { notifyHostSignSuccess } from "../../utils/notifyHost";

export default {
  name: "Signature-vue",
  components: { SignImg, DragImg },
  data() {
    return {
      loading: false,
      show: false,
      submitabl: false,
      signImgBase64: "",
      signImgShow: false,
      sealImgCount: 0,
      sealImgReuseCount: 0,
      signImgUrl: null,
      url: "",
      tokenkey: "",
      pdfid: "",
      api: "",
      sealUrl: "",
      signPositions: [],
      filledSignSlots: 0,
      signerName: "",
    };
  },
  computed: {
    enableSeal() {
      return (
        hasBackendSeal(this.sealUrl) &&
        this.signPositions.some((p) => p.type === "seal")
      );
    },
    completeUrl() {
      return buildApiPaths(this.api).completeUrl;
    },
  },
  methods: {
    /**
     * @param {object} options
     * @param {string} options.pdfUrl
     * @param {string} options.token
     * @param {string|number} options.contractId
     * @param {string} options.api
     * @param {string} [options.sealUrl]
     * @param {Array} [options.signPositions]
     */
    init(options = {}) {
      this.show = true;
      this.submitabl = false;
      this.url = options.pdfUrl || "";
      this.tokenkey = options.token || "";
      this.pdfid = options.contractId || "";
      this.api = (options.api || "").replace(/\/$/, "");
      this.sealUrl = options.sealUrl || "";
      this.signPositions = this.parseSignPositions(options.signPositions);
      this.filledSignSlots = 0;
      this.signerName = String(options.signerName || "").trim();
      this.signImgShow = false;
      this.$nextTick(() => {
        if (this.url) {
          this.openPdf(this.url);
        } else {
          this.$message.error("合同 PDF 地址无效");
        }
      });
    },
    pauseHandle() {
      return this.loading;
    },
    print() {
      let print = this.$refs.pdfViewer.innerHTML;
      let printPart = print + printStyle;
      let newTab = window.open("_blank");
      newTab.document.body.innerHTML = printPart;
      newTab.print();
      newTab.close();
    },
    handleExceed(file, fileList) {
      var type = file.type.substring(0, file.type.lastIndexOf("/"));
      if (type !== "image") {
        this.$message.error("只支持上传图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传的图片大小不能超过 2MB!");
      }
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 1 个文件，共选择了 2 个文件`
      );
    },
    handleBeforeUpload1(file) {
      var type = file.type.substring(
        file.type.lastIndexOf("/") + 1,
        file.type.length
      );
      if (type !== "pdf" && type !== "PDF") {
        this.$message.error("请上传pdf类型文件!");
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传的文件大小不能超过 10MB!");
        return;
      }
      this.submitabl = false;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        this.isPdfShow = false;
        reader.onload = () => {
          // 将 base64 数据保存到上传数据中
          this.url = reader.result;
          resolve(file);
          // this.preViewPdf = 'preViewPdf'+ new Date().getTime()
          this.$message.success("上传成功");
          this.init();
        };
        reader.onerror = (error) => {
          this.isPdfShow = true;
          this.$message.warning("上传失败");
          reject(error);
        };
      });
    },
    handleBeforeUpload(file) {
      var type = file.type.substring(0, file.type.lastIndexOf("/"));
      if (type !== "image") {
        this.$message.error("只支持上传图片!");
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传的图片大小不能超过 2MB!");
        return;
      }
      this.deleteDragImg(true);
      this.submitabl = false;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // 将 base64 数据保存到上传数据中
          this.signImgBase64 = reader.result;
          console.log(this.signImgBase64);
          resolve(file);
          this.$message.success("上传成功");
        };
        reader.onerror = (error) => {
          this.$message.warning("上传失败");
          reject(error);
        };
      });
    },
    /** 关闭窗口操作 */
    closeDialog() {
      this.show = false;
      // this.$emit('update:show', false);
    },
    //签名框方法
    showFunction() {
      this.signImgShow = this.signImgShow ? false : true;
    },
    signSuccess(imgData, isReuse) {
      this.massage = "请确认签名位置后提交";
      this.signImgShow = false;
      this.signImgBase64 = imgData;

      const signSlots = this.signPositions.filter((p) => p.type === "sign");
      if (signSlots.length) {
        // 一次确认：同一文字签落到全部签名位（接近 e签宝）
        this.filledSignSlots = 0;
        signSlots.forEach((slot) => {
          this.placeAtPosition(imgData, "sign", slot, isReuse);
          this.removePlaceholderForSlot(slot);
          this.filledSignSlots++;
        });
        return;
      }
      this.seal(imgData, "sign", isReuse);
    },
    parseSignPositions(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
    getNextSignSlot() {
      const signSlots = this.signPositions.filter((p) => p.type === "sign");
      if (!signSlots.length) return null;
      return signSlots[this.filledSignSlots] || null;
    },
    removePlaceholderForSlot(slot) {
      if (!slot) return;
      const pageEl = this.getPageElement(slot.page);
      if (!pageEl) return;
      const key = this.getSlotKey(slot);
      const nodes = pageEl.querySelectorAll(`[data-slot-key="${key}"]`);
      nodes.forEach((node) => node.remove());
    },
    getSlotKey(slot) {
      return `${slot.page}-${slot.type}-${slot.x}-${slot.y}`;
    },
    getPageElement(pageNum) {
      const num = Number(pageNum);
      if (!num) return null;
      const byClass = document.querySelector(
        `.pdfViewer .pageContainer${num}`
      );
      if (byClass) return byClass;
      if (this.pdfh5 && this.pdfh5.pages && this.pdfh5.pages[num - 1]) {
        return this.pdfh5.pages[num - 1];
      }
      return null;
    },
    ensurePageRelative(pageEl) {
      if (pageEl && getComputedStyle(pageEl).position === "static") {
        pageEl.style.position = "relative";
      }
    },
    waitForPageElement(pageNum, retries = 10, interval = 200) {
      return new Promise((resolve) => {
        let count = 0;
        const tryFind = () => {
          const el = this.getPageElement(pageNum);
          if (el && el.clientWidth > 0) {
            resolve(el);
            return;
          }
          count++;
          if (count >= retries) {
            resolve(null);
            return;
          }
          setTimeout(tryFind, interval);
        };
        tryFind();
      });
    },
    async applySignLayout() {
      if (!this.signPositions.length) return;
      await this.waitForPageElement(1);
      this.showPlaceholders();
      this.autoPlaceSeals();
    },
    clearPlaceholders() {
      const nodes = document.querySelectorAll(".sign-position-placeholder");
      nodes.forEach((node) => node.remove());
    },
    showPlaceholders() {
      this.clearPlaceholders();
      if (!this.signPositions.length || !this.pdfh5 || !this.pdfh5.pages) {
        return;
      }
      this.signPositions.forEach((slot) => {
        if (slot.type === "seal" && !this.enableSeal) return;
        const pageEl = this.getPageElement(slot.page);
        if (!pageEl) return;
        this.ensurePageRelative(pageEl);
        const placeholder = document.createElement("div");
        placeholder.className = "sign-position-placeholder";
        placeholder.setAttribute("data-slot-key", this.getSlotKey(slot));
        placeholder.style.left = `${slot.x * 100}%`;
        placeholder.style.top = `${slot.y * 100}%`;
        placeholder.style.width = `${slot.width * 100}%`;
        placeholder.style.height = `${slot.height * 100}%`;
        const label =
          slot.label ||
          (slot.type === "sign"
            ? "请在此签名"
            : this.enableSeal
            ? "盖章区"
            : "");
        if (!label) return;
        placeholder.innerHTML = `<span>${label}</span>`;
        pageEl.appendChild(placeholder);
      });
    },
    autoPlaceSeals() {
      if (!this.enableSeal) return;
      const sealSlots = this.signPositions.filter((p) => p.type === "seal");
      if (!sealSlots.length) return;
      sealSlots.forEach((slot) => {
        this.placeAtPosition(this.sealUrl, "seal", slot, false);
        this.removePlaceholderForSlot(slot);
      });
    },
    async placeAtPosition(imgData, type, position, isReuse) {
      const pageEl = await this.waitForPageElement(position.page);
      if (!pageEl) {
        console.error("未找到 PDF 页面容器", position.page);
        this.$message.error("PDF 页面未就绪，请稍后重试");
        return;
      }
      this.ensurePageRelative(pageEl);
      const pageWidth = pageEl.clientWidth || 1;
      const pageHeight = pageEl.clientHeight || 1;
      const leftPx = position.x * pageWidth;
      const topPx = position.y * pageHeight;
      const widthPx = (position.width || 0.2) * pageWidth;
      const heightPx = (position.height || 0.08) * pageHeight;

      this.submitabl = true;
      const dragImg = Vue.extend(DragImg);
      const app = new dragImg({
        propsData: {
          deleteDragImg: this.deleteDragImg,
          imgData: imgData || this.signImgBase64 || this.sealUrl,
          isReuse: isReuse,
          top: 0,
          imgType: type,
          pauseHandle: this.pauseHandle,
          fixedPosition: true,
          initialLeftPx: leftPx,
          initialTopPx: topPx,
          initialWidthPx: widthPx,
          initialHeightPx: heightPx,
        },
        ref: "a",
      }).$mount(document.createElement("div"));
      this.sealImgCount++;
      if (isReuse) {
        this.sealImgReuseCount++;
      }
      pageEl.appendChild(app.$el);
    },
    //签名框方法end
    openPdf(url) {
      this.visible = true;
      console.log('打开PDF:', url);
      try {
        this.pdfh5 = new Pdfh5("#preViewPdf", {
          pdfurl: url,
          maxZoom: 1,
          pageNum: true,
        });
        
        // 监听PDF加载错误
        this.pdfh5.on('error', (error) => {
          console.error('PDF加载错误:', error);
          this.$message.error('PDF文件加载失败，请检查网络连接或文件路径');
        });
        
        // 监听PDF加载完成
        this.pdfh5.on('complete', (status, msg, time) => {
          console.log('PDF加载状态:', status, msg, time);
          if (status !== 'success') {
            this.$message.warning('PDF文件加载可能不完整');
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.applySignLayout();
              if (!this.signPositions.length) {
                this.massage =
                  "请点击下方「使用签名」，选择文字签名样式后提交";
              }
            }, 300);
          });
        });
      } catch (error) {
        console.error('PDF初始化错误:', error);
        this.$message.error('PDF文件初始化失败，请检查文件路径是否正确');
      }
    },
    sign() {
      this.removeSignOverlays();
      this.filledSignSlots = 0;
      this.signImgShow = true;
    },
    removeSignOverlays() {
      const pdfViewer = document.querySelector(".pdfViewer");
      if (!pdfViewer) return;
      pdfViewer.querySelectorAll('.dragImg[data-fixed-sign="1"]').forEach((el) => {
        if (el.querySelector(".imgType_sign")) {
          el.remove();
          this.sealImgCount = Math.max(0, this.sealImgCount - 1);
        }
      });
      if (this.signPositions.length) {
        this.showPlaceholders();
      }
    },
    undo() {
      this.pdfh5.options.backTop = false;
    },
    //删除图片
    deleteDragImg(isReuse) {
      this.sealImgCount--;
      if (isReuse) {
        this.sealImgReuseCount--;
      }
      if (this.sealImgCount === 0) {
        this.submitabl = false;
      }
    },
    seal(imgData, type, isReuse) {
      console.log(imgData, type, isReuse, "状态");

      if (!this.signImgBase64 && !this.sealUrl && type != "sign")
        return this.$message.warning("请选择印章");
      this.submitabl = true;
      let scrollt =
        document.querySelector(".pdfViewer").parentElement.parentElement
          .scrollTop;
      var dragImg = Vue.extend(DragImg);
      const app = new dragImg({
        propsData: {
          deleteDragImg: this.deleteDragImg,
          imgData: imgData || this.signImgBase64 || this.sealUrl,
          isReuse: isReuse,
          top: scrollt,
          // currentPageNum:this.pdfh5.currentNum,
          // currentPageNum: this.pdfh5.pageNow[0].innerText,
          imgType: type,
          pauseHandle: this.pauseHandle,
        },
        ref: "a",
      }).$mount(document.createElement("div"));
      this.sealImgCount++;
      if (isReuse) {
        this.sealImgReuseCount++;
      }
      const pageIndex = parseInt(this.pdfh5.pageNow[0].innerText) - 1;
      const targetPage = this.pdfh5.pages[pageIndex];
      if (targetPage) {
        targetPage.appendChild(app.$el);
      }
    },
    savePdf() {
      // 检查是否有签名或印章
      let pdfViewer = document.querySelector(".pdfViewer");
      let dragImgs = Array.from(pdfViewer.querySelectorAll(".dragImg"));
      
      if (dragImgs.length === 0) {
        this.$message.error('请先添加签名或印章');
        return;
      }

      const requiredSignCount = this.signPositions.filter(
        (p) => p.type === 'sign' && p.required !== false
      ).length;
      const signCount = dragImgs.filter((el) =>
        el.querySelector('.imgType_sign')
      ).length;
      if (requiredSignCount > 0 && signCount < requiredSignCount) {
        this.$message.error(`请完成全部签名（${signCount}/${requiredSignCount}）`);
        return;
      }
      
      //隐藏图片操作按钮
      var imgBtn = document.getElementsByClassName("imgBtn");
      if (imgBtn) {
        for (let i = 0; i < imgBtn.length; i++) {
          imgBtn[i].style.display = "none";
        }
      }
      //隐藏签名盖章按钮
      // this.signOrSeal = '';
      // this.showSubmit = false;
      //提交
      this.loading = true;
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.signPositions.length > 0) {
            this.getPdf();
          } else {
            this.setSign();
          }
        });
      }, 500);
    },
    // 将签名或印章放到对应页面中
   async setSign() {
      const firstPage = document.querySelector(".pdfViewer .pageContainer1");
      let baseNum = firstPage ? firstPage.clientHeight : 1263.85; // 动态获取页面高度或使用默认值
      const secondPage = document.querySelector(".pdfViewer .pageContainer2");
      let pageMargin = 0;
      if (firstPage && secondPage) {
        // 获取两个页面容器的边界矩形
        const firstRect = firstPage.getBoundingClientRect();
        const secondRect = secondPage.getBoundingClientRect();

        // 计算两页之间的垂直距离
        pageMargin = secondRect.top - firstRect.bottom;

        console.log(
          "The margin between the first and second pages is:",
          pageMargin,
          "pixels"
        );
      } else {
        console.log(
          "Could not find both the first and second page containers."
        );
      }
      let pdfViewer = document.querySelector(".pdfViewer");
      let dragImgs = Array.from(pdfViewer.querySelectorAll(".dragImg"));

      if (dragImgs.length === 0) {
        console.warn("未找到任何 dragImg 元素");
        return;
      }

      await Promise.all(
        dragImgs.map(async (container) => {
          try {
            if (container.getAttribute("data-fixed-sign") === "1") {
              return;
            }
            let ele = container.querySelector("#pic");
            if (!ele) {
              console.warn("签名或印章容器内没有找到 #pic 元素", container);
              return;
            }

            let eleImg = ele.querySelector("div");

            let top = parseFloat(window.getComputedStyle(ele).top) || 0;
            let topImg = parseFloat(window.getComputedStyle(eleImg).top) || 0;
            let currentTop = top + topImg;

            if (currentTop > baseNum) {
              let pageIndex = Math.ceil(currentTop / baseNum);

              let targetPageContainer = document.querySelector(
                `.pdfViewer .pageContainer${pageIndex}`
              );

              if (!targetPageContainer) {
                console.error("未能找到目标页面容器", pageIndex);
                return;
              }

              // 计算相对于新页面顶部的位置
              let relativeTop =
                currentTop - (pageIndex - 1) * (baseNum + pageMargin);
              ele.style.top = `${relativeTop}px`;
              eleImg.style.top = "0px"; // 重置内部图片的位置为顶部

              targetPageContainer.appendChild(container);
            } else {
              // 确保签名或印章容器仍在当前页面内
              let defaultPageContainer = document.querySelector(
                ".pdfViewer .pageContainer1"
              );
              if (!defaultPageContainer) {
                console.error("未能找到初始页面容器");
                return;
              }
              defaultPageContainer.appendChild(container);
            }
          } catch (error) {
            console.error("Error processing signature/seal:", error);
          }
        })
      );

      this.$nextTick(() => {
        setTimeout(() => {
          this.getPdf();
        }, 500); // 减少延迟时间，因为不再依赖于dragImgs的数量
      });
    },
    // 生成下载pdf
    getPdf() {
      let that = this;
      //防止截图不全
      document.querySelector(
        ".pdfViewer"
      ).parentElement.parentElement.scrollTop = 0;
      document.querySelector(
        ".pdfViewer"
      ).parentElement.parentElement.scrollLeft = 0;
      let parent = document.querySelector(".pdfViewer");
      // 生成图片
      let PDF = new JsPDF("", "pt", "a4");
      let length = parent.children.length;
      for (let i = 0; i < length; i++) {
        // 绘制图片
        html2canvas(parent.children[i]).then(function (canvas) {
          if (parent.children[i].className != "dragImg") {
            let url = canvas.toDataURL();
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            let pageHeight = (contentWidth / 592.28) * 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            let imgWidth = 595.28;
            let imgHeight = (592.28 / contentWidth) * contentHeight;
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            console.log(
              canvas.width,
              canvas.height,
              pageHeight,
              leftHeight,
              imgWidth,
              imgHeight,
              i
            );
            if (i != 0) PDF.addPage();
            if (leftHeight < pageHeight) {
              PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
            } else {
              if (leftHeight > 0) {
                PDF.addImage(
                  pageData,
                  "JPEG",
                  0,
                  position,
                  imgWidth,
                  imgHeight
                );
                leftHeight -= pageHeight;
                position -= 841.89;
              }
            }
          }
          if (length - 1 == i) {
            setTimeout(() => {
              console.log(
                "总页:",
                length,
                PDF.internal.getNumberOfPages(),
                PDF
              );
              // 获取PDF文件的二进制数据
              const pdfBlob = PDF.output("blob");
              console.log('PDF Blob:', pdfBlob);
              
              // 将Blob转换为File对象
              const pdfFile = new File([pdfBlob], "contract.pdf", { type: "application/pdf" });
              console.log('PDF File:', pdfFile);
              
              var formData = new FormData();
              formData.append("pdf", pdfFile);
              formData.append("contract_id", that.pdfid);
              
              // 打印FormData内容
              for (let pair of formData.entries()) {
                console.log('FormData:', pair[0], pair[1]);
              }

              that.pdfsave(formData, that.tokenkey);
            }, 1000);
          }
        });
      }
    },
    async pdfsave(obj, key) {
      try {
        const apiUrl = this.completeUrl;
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            Authorization: formatAuthHeader(key),
          },
          body: obj,
        });
        
        console.log('响应状态:', response.status);
        console.log('响应头:', Object.fromEntries(response.headers.entries()));
        
        if (!response.ok) {
          // 尝试获取错误响应
          const errorText = await response.text();
          console.error('错误响应:', errorText);
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }

        // 尝试解析响应
        const text = await response.text();
        console.log('上传响应文本:', text);
        
        // 检查是否是JSON格式
        let data;
        try {
          data = JSON.parse(text);
          console.log('上传响应:', data);
        } catch (e) {
          throw new Error(`Invalid JSON response: ${text.substring(0, 100)}...`);
        }

        if (data.code == 200) {
          this.$message({
            message: data.message || '签署成功',
            type: "success",
          });

          // 通知宿主并主动返回（微信 postMessage 仅在 web-view 销毁时送达）
          setTimeout(() => {
            notifyHostSignSuccess(data.message || '签署成功');
          }, 400);
        } else {
          this.$message.error(data.message || '签署失败');
        }
      } catch (error) {
        console.error("上传失败:", error);
        // 显示详细的错误信息
        if (error.message.includes('Invalid JSON response')) {
          this.$message.error('接口返回格式错误，请检查接口地址');
        } else if (error.message.includes('HTTP error')) {
          this.$message.error(`接口请求失败: ${error.message}`);
        } else {
          this.$message.error('上传失败，请重试');
        }
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.show = false;
    },

    downloadPdf(blob) {
      const that = this;
      const file = new FileReader();
      file.readAsText(blob, "utf-8");
      file.onload = function () {
        // 判断返回的是数据流还是json对象
        if (that.isJSON(file.result)) {
          // 若返回的是json对象，不进行下载操作
          const jsonData = JSON.parse(file.result);
          this.$message.error(jsonData.message || "下载失败");
          return;
        } else {
          // 若返回的是不是json对象，进行下载操作
          const fileUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = "test.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      };
    },
    isJSON(str) {
      if (typeof str == "string") {
        try {
          let obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(",");
      //注意base64的最后面中括号和引号是不转译的
      var _arr = arr[1].substring(0, arr[1].length - 2);
      var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },

    // * desc: 下载方法
    // * @param url  ：返回数据的blob对象或链接
    // * @param fileName  ：下载后文件名标记
    downloadFile(url, name = "What's the fuvk") {
      console.log("url==", url);
      var a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      let clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
  },
};
</script>

<style scoped>
::v-deep .sign-contract-dialog {
  background: transparent !important;
}

::v-deep .sign-contract-dialog .el-dialog__header {
  display: none;
}

::v-deep .sign-contract-dialog .el-dialog__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: hidden !important;
  background: transparent !important;
}

.sign-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f3f4f6;
}

.sign-page__tip {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
  padding: 10px 16px;
  font-size: 12px;
  line-height: 1.4;
  color: #8b5a3c;
  background: linear-gradient(90deg, #fff7f0 0%, #fff 100%);
  border-bottom: 1px solid #f0e4da;
}

.sign-page__tip-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e4572e;
}

.sign-page__pdf {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

#preViewPdf {
  height: 100%;
  background: #f3f4f6;
}

.sign-page__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  border-top: 1px solid #eef0f3;
  box-shadow: 0 -6px 24px rgba(15, 23, 42, 0.04);
}

.sign-page__btn {
  flex: 1;
  height: 46px;
  margin: 0;
  border: none;
  border-radius: 23px;
  font-size: 15px;
  font-weight: 560;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.15s;
}

.sign-page__btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.sign-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.sign-page__btn--ghost {
  color: #e4572e;
  background: #fff5f1;
  border: 1px solid rgba(228, 87, 46, 0.28);
}

.sign-page__btn--primary {
  flex: 1.25;
  color: #fff;
  background: linear-gradient(135deg, #f06a45 0%, #e4572e 100%);
  box-shadow: 0 8px 18px rgba(228, 87, 46, 0.28);
}

/* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
.el-dialog.is-fullscreen::-webkit-scrollbar {
  display: none;
}

.el-dialog.is-fullscreen {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

<style>
/* PDF 页码胶囊 */
#preViewPdf .pageNum {
  top: 12px !important;
  right: 12px !important;
  left: auto !important;
  width: auto !important;
  min-width: 0 !important;
  height: auto !important;
  padding: 0 !important;
  background: transparent !important;
}

#preViewPdf .pageNum-bg {
  display: none !important;
}

#preViewPdf .pageNum-num {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  height: 28px;
  padding: 0 10px;
  font-size: 12px !important;
  font-weight: 500;
  color: #5c6570 !important;
  background: rgba(255, 255, 255, 0.92) !important;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

#preViewPdf .viewerContainer,
#preViewPdf .pdfViewer {
  background: #f3f4f6 !important;
}

#preViewPdf .pdfViewer .pageContainer {
  position: relative !important;
  width: calc(100% - 24px) !important;
  margin: 12px auto !important;
  overflow: hidden !important;
  border-radius: 8px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
  background: #fff;
}

.sign-position-placeholder {
  position: absolute;
  box-sizing: border-box;
  border: 1.5px dashed rgba(228, 87, 46, 0.55);
  background: rgba(228, 87, 46, 0.06);
  color: #e4572e;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 120;
  pointer-events: none;
  text-align: center;
  padding: 4px;
  border-radius: 4px;
}

.sign-position-placeholder span {
  line-height: 1.3;
}
</style>
